module.exports = __webpack_public_path__ + "img/ic-mobile-right-1.dd7fa10c.webp";